import React from 'react';
import { AllieIconProps } from '../../..';

export const ArrowRightIcon: React.FC<AllieIconProps> = ({
  size = '12',
  color = 'var(--allie-color-neutral-50)',
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 12 12"
      fill="none"
    >
      <path
        d="M0.833328 5.75H11.25M11.25 5.75L6.25 0.75M11.25 5.75L6.25 10.75"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
